import { Box, forwardRef } from '@chakra-ui/react';

type InlineContentProps = object;

export const InlineContent = forwardRef<InlineContentProps, 'span'>((props, ref) => {
    return <Box ref={ref} as={props.as || 'span'} {...props} />;
});
